import { useEffect, useState, type RefObject } from "react";
import { getScrollParent } from "./useScrollState";

export const useScrollerHeight = ({ ref }: { ref: RefObject<HTMLElement | null> }) => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const target = getScrollParent({ element: ref.current });
    if (target === window) {
      const read = () => setHeight(window.innerHeight);
      read();
      window.addEventListener("resize", read);
      return () => window.removeEventListener("resize", read);
    }
    const element = target as HTMLElement;
    const read = () => setHeight(element.clientHeight);
    read();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(read);
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);

  return height;
};
